import React, { useEffect, useState } from 'react'

import { OneModal } from '@yy/one-ui'
import styles from './index.module.less'
import { getPop, notifyRead } from '@/services/api'

import { useTranslation } from 'react-i18next'
import { convertData } from '../../utils'
import { useModalImgPreview } from '../../hook'

const BellNotice = () => {
  const { t, i18n } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [noticeData, setNoticeData] = useState(null)
  const [noticeID, setNoticeID] = useState('')

  const { showPreviewModal, previewModal } = useModalImgPreview()

  useEffect(() => {
    getPop({}).then((res) => {
      if (res.data) {
        const data = convertData([res.data], i18n)[0]
        setNoticeID(res.data.id)
        setNoticeData(data)
        setVisible(true)
      }
    })
  }, [i18n])

  const bodyStyle = {}
  let bodyheight = window.document.body.clientHeight - 200
  if (bodyheight < 500) {
    bodyheight = 500
  }

  useEffect(() => {
    if (visible) {
      const noticeDom = document.querySelector('#noticeContentOne')
      noticeDom?.addEventListener('click', (e) => {
        const target = e.target as Element
        const { tagName } = target
        if (tagName === 'IMG') {
          const src = target.getAttribute('src')
          showPreviewModal(src)
        }
      })
    }
  }, [showPreviewModal, visible])

  const setRead = () => {
    notifyRead({ notifyRecordIds: [noticeID] })
  }

  let isAnimationing = false
  const startAnimation = () => {
    if (isAnimationing) {
      return
    }
    isAnimationing = true
    const BellNoticeModal: HTMLDivElement = document.querySelector('.BellNoticeModal')
    BellNoticeModal.style.visibility = 'hidden'
    const bell: HTMLDivElement = document.querySelector('#bellCenterIcon')
    const bellWidth = bell.offsetWidth //图标宽度
    const bellHeight = bell.offsetHeight //图标高度
    const bellRight = bell.getBoundingClientRect().right //距离左边的距离
    const bellBottom = bell.getBoundingClientRect().bottom // 顶部距离

    const BellNoticeModalWidth = BellNoticeModal.offsetWidth //弹框宽度
    const BellNoticeModalHeight = BellNoticeModal.offsetHeight //弹框高度
    const BellNoticeModalLeft = BellNoticeModal.getBoundingClientRect().left //距离左边的距离
    const BellNoticeModalTop = BellNoticeModal.getBoundingClientRect().top // 顶部距离
    const BellNoticeModalClone: HTMLDivElement = BellNoticeModal.cloneNode(true) as HTMLDivElement
    BellNoticeModalClone.style.cssText = `
          visibility:visible;
          z-index:9999999;
          opacity:1;
          position:fixed;
          width:${BellNoticeModalWidth}px;
          height:${BellNoticeModalHeight}px;
          top:${BellNoticeModalTop}px;
          left:${BellNoticeModalLeft}px;
          transition: all 1s ease-in-out;
        `
    document.body.appendChild(BellNoticeModalClone)
    setTimeout(() => {
      BellNoticeModalClone.style.left = `${bellRight - BellNoticeModalWidth / 2 - bellWidth / 2}px`
      BellNoticeModalClone.style.top = `${bellBottom - BellNoticeModalHeight / 2 - bellHeight / 2}px`
      BellNoticeModalClone.style.transform = 'scale(0)'
      BellNoticeModalClone.style.opacity = '.5'
    }, 0)

    setTimeout(() => {
      BellNoticeModalClone.parentNode.removeChild(BellNoticeModalClone)
      setVisible(false)
      setTimeout(() => {
        BellNoticeModal.style.visibility = 'visible'
      }, 500)

      setRead()
      isAnimationing = false
    }, 1000)
  }

  return (
    <>
      {previewModal}
      <OneModal
        className="BellNoticeModal"
        width={620}
        height={bodyheight + 'px'}
        onCancel={() => {
          startAnimation()
        }}
        bodyStyle={bodyStyle}
        closable={true}
        title={noticeData?.title}
        visible={visible}
        footer={
          <div
            className={styles.footerBtn}
            onClick={() => {
              startAnimation()
            }}
          >
            {t('common.confirm')}
          </div>
        }
      >
        <div className={styles.noticeContent} id="noticeContentOne">
          {noticeData && (
            <div className={styles.noticeItems}>
              <div dangerouslySetInnerHTML={{ __html: noticeData.content }} className={styles.content}></div>
            </div>
          )}
        </div>
      </OneModal>
    </>
  )
}

export default BellNotice
